import React from 'react';
import ProjectSidebarComponent from './ProjectSidebarComponent';
import { PageHeader } from '../../components';

const ElectrodeionizationEdi: React.FC = () => {
  return (
    <>
      <PageHeader title="Electrodeionization (EDI)" breadcrumbs={[{ label: "Projects", path: "/projects" }]} />

      <div className="container-fluid py-5 wow fadeInUp" data-wow-delay="0.1s"
        style={{ visibility: "visible", animationDelay: "0.1s", animationName: "fadeInUp" }}>
        <div className="container">
          <div className="row g-5">

            <div className="col-lg-8">
              <div className="row g-3 mb-5">
                <div className="col-md-12">
                  <img className="img-fluid" src="img/edi.jpg" alt="" />
                </div>
              
              </div>
              <h1 className="mb-4">Electrodeionization (EDI)</h1>
              
              <h3 className="mb-4">Overview</h3>
              <p>Electrodeionization (EDI) is a cutting-edge water purification technology that combines ion exchange resins with electricity to continuously produce ultrapure, demineralized water without the need for chemical regeneration. At Wasser Technochem (India) Ltd., we design and integrate EDI systems for industries requiring high-purity, low-conductivity water, especially in the pharmaceutical, electronics, and power sectors.</p>
              <p>EDI is typically used as a polishing step after RO or DM units, offering a green, cost-efficient alternative to mixed bed resins.</p>

              <h3 className="mb-4">Applications</h3>
              <p><i className="fa fa-pills text-primary me-2"></i>Pharmaceutical-grade water production (USP/BP standards)</p>
              <p><i className="fa fa-fire text-primary me-2"></i>Boiler feedwater for supercritical and ultra-supercritical boilers</p>
              <p><i className="fa fa-microchip text-primary me-2"></i>Semiconductor and microelectronics fabrication</p>
              <p><i className="fa fa-flask text-primary me-2"></i>Laboratory and medical-grade ultrapure water</p>
              <p><i className="fa fa-wine-bottle text-primary me-2"></i>Food and beverage processing</p>
              <p><i className="fa fa-battery-half text-primary me-2"></i>Battery manufacturing & cleanroom processes</p>

              <h3 className="mb-4">Our Capabilities</h3>
              <p className="mb-4">WTIL provides custom-engineered EDI skids with fully integrated RO + EDI systems, catering to high-purity water needs across Indian industrial and institutional sectors.</p>
              
              <div className="mb-4">
                <h5><i className="fa fa-chart-line text-primary me-2"></i>Module Ratings: 0.5 m³/hr to 20+ m³/hr</h5>
                <p className="ms-4">Configurable for scalable, continuous operations.</p>
              </div>

              <div className="mb-4">
                <h5><i className="fa fa-award text-primary me-2"></i>Leading EDI Technologies</h5>
                <p className="ms-4">We use modules from global OEMs like Evoqua, Ionpure, Veolia (GE) etc.</p>
              </div>

              <div className="mb-4">
                <h5><i className="fa fa-leaf text-primary me-2"></i>No Chemical Regeneration</h5>
                <p className="ms-4">Environment-friendly process with low operational complexity.</p>
              </div>

              <div className="mb-4">
                <h5><i className="fa fa-desktop text-primary me-2"></i>Integrated with PLC/SCADA Automation</h5>
                <p className="ms-4">For conductivity monitoring, flow control, and interlocks.</p>
              </div>

              <div className="mb-4">
                <h5><i className="fa fa-bolt text-primary me-2"></i>Electrically Driven Deionization</h5>
                <p className="ms-4">Ensures constant output with minimal manual intervention.</p>
              </div>

              <h3 className="mb-4">Benefits</h3>
              <p><i className="fa fa-check-circle text-success me-2"></i>Produces ultrapure water with conductivity &lt; 0.2 µS/cm</p>
              <p><i className="fa fa-check-circle text-success me-2"></i>No need for acid/alkali regeneration</p>
              <p><i className="fa fa-check-circle text-success me-2"></i>Continuous, uninterrupted operation</p>
              <p><i className="fa fa-check-circle text-success me-2"></i>Compact, modular, and low-maintenance design</p>

              <h3 className="mb-4">Why WTIL?</h3>
              <p><i className="fa fa-star text-warning me-2"></i>Proven expertise in RO+EDI integration for pharma and power clients</p>
              <p><i className="fa fa-star text-warning me-2"></i>Turnkey services including feed study, design, fabrication, commissioning</p>
              <p><i className="fa fa-star text-warning me-2"></i>In-house automation, electrical panel design, and after-sales support</p>
              <p className="mb-5"><i className="fa fa-star text-warning me-2"></i>Support for validation documentation and audit compliance</p>
            </div>

            <div className="col-lg-4">
              <ProjectSidebarComponent />
            </div>

          </div>
        </div>
      </div>
    </>
  );
};

export default ElectrodeionizationEdi;
